import type { ComponentVersions } from './ComponentVersionsContext'

/*
Once a version goes live/public, it should be 'frozen'.
This prevents visual regressions in existing views.
*/
export const ComponentVersions_2_0: ComponentVersions = {
  button: 1,
  chip: 1,
  icon_button: 1,
  switch: 1,
  checkbox: 1,
  radio: 1,
  alert: 1,
  table: 1,
  dialog: 1,
  select: 1,
  text_field: 1,
  field_title: 1,
  date_picker: 1,
  date_time_picker: 1,
  tooltip: 1,
  snackbar: 1,
  snackbar_content: 1,
  typography: 1,
  drawer: 1,
  accordion: 1,
  tabs: 1,
  badge: 1,
  menu: 1,
  table_pagination: 1,
  mui_compat: 1,
  popover: 1,
}

export const ComponentVersions_2_1: ComponentVersions = { ...ComponentVersions_2_0, button: 2 }

export const ComponentVersions_3_0: ComponentVersions = {
  button: 3,
  chip: 2,
  icon_button: 2,
  switch: 2,
  checkbox: 2,
  radio: 2,
  alert: 2,
  table: 2,
  dialog: 2,
  select: 2,
  text_field: 2,
  field_title: 2,
  date_picker: 2,
  date_time_picker: 2,
  tooltip: 2,
  snackbar: 2,
  snackbar_content: 2,
  skeleton: 2,
  typography: 2,
  drawer: 2,
  accordion: 2,
  tabs: 2,
  badge: 2,
  menu: 2,
  table_pagination: 2,
  mui_compat: 2,
  popover: 2,
}
